module.exports = __webpack_public_path__ + "static/img/4.dbadb55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/02/4.png
// module id = Mwcl
// module chunks = 1